import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useDemoStore } from '../../pinia/index'
import getApiUrl from './api';
import { getRealJsonData } from "../../hooks/realJson";
import { numberStringConversion } from "../convertNumericStrings";
import { watch } from 'vue';
const store = useDemoStore();
const instance = axios.create({
  baseURL:getApiUrl(),
  timeout: 100000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  },
  transformResponse: [
    (data) => {
      return getRealJsonData(data);
    },
  ],  
})
watch(()=>store.server,(newVal,oldVal)=>{
  instance.defaults.baseURL = getApiUrl();
})


/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(
  config => {
    // 请求头添加token
    config.headers['Authorization'] = `${store.token}`
    config.headers['Accept-Language'] = `${store.lang}`
    config.headers["codeKey"] = store.codeKey
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  response => {
    const res = response.data;
    if(res.code == 200){
      return res;
    }else if(res.code == 201){
      ElMessage(res.msg);
      return res;
    } else if (res.code == 301) {
      location.reload();
      return res;
    }else{
      ElMessage(res.msg);
      return res;
    }
  },
  error => {
    ElMessage(error.message);
    return Promise.reject(error.message);
  }
)
export default instance
